var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-activator", class: _vm.variantClass },
    [
      _vm._t("default", null, null, _vm.bindings),
      _vm._v(" "),
      _c("transition", { attrs: { name: _vm.transition } }, [
        _vm.isActive
          ? _c(
              "div",
              { ref: "modalOverlay", staticClass: "modal-overlay" },
              [
                _c(
                  "div",
                  {
                    ref: "modalWrapper",
                    staticClass: "modal-wrapper",
                    class: [
                      { active: _vm.isActive },
                      { mounted: this.isMounted },
                      _vm.customClass,
                    ],
                    attrs: {
                      role: _vm.isAlertDialog ? "alertdialog" : "dialog",
                      "aria-modal": "true",
                      "aria-labelledby": _vm.ariaLabelledBy,
                    },
                  },
                  [
                    _vm.variantClass === "mobile-swipe-variant"
                      ? _c(
                          "div",
                          {
                            staticClass: "modal-swipe",
                            on: {
                              mousedown: _vm.startDrag,
                              touchstart: _vm.startDrag,
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "78",
                                  height: "5",
                                  viewBox: "0 0 78 5",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("rect", {
                                  attrs: {
                                    width: "78",
                                    height: "5",
                                    rx: "2.5",
                                    fill: "#D1D1D1",
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { ref: "header", staticClass: "modal-header" },
                      [
                        !_vm.isAlertDialog
                          ? _c(
                              "button",
                              {
                                staticClass: "close-cta",
                                attrs: {
                                  "aria-label": _vm.tc("booking.close"),
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.deactivate($event)
                                  },
                                },
                              },
                              [
                                _vm._t("close", [
                                  _c("span", { staticClass: "icon-close" }),
                                ]),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("header"),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-body", style: _vm.modalBodyStyle },
                      [_vm._t("body", null, null, _vm.bindings)],
                      2
                    ),
                    _vm._v(" "),
                    !_vm.noFooter
                      ? _c(
                          "div",
                          { ref: "footer", staticClass: "modal-footer" },
                          [
                            _vm.customFooter
                              ? [_vm._t("footer", null, null, _vm.bindings)]
                              : [
                                  _vm.ctaCloseText
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "close-cta",
                                          attrs: {
                                            disabled:
                                              _vm.ctaCloseDisabled ||
                                              _vm.isLoading ||
                                              !_vm.ctaCloseText,
                                          },
                                          on: { click: _vm.deactivate },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.ctaCloseText) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "confirm-cta",
                                      class: [
                                        {
                                          loading:
                                            _vm.isLoading || !_vm.ctaText,
                                        },
                                      ],
                                      attrs: {
                                        disabled:
                                          _vm.ctaDisabled ||
                                          _vm.isLoading ||
                                          !_vm.ctaText,
                                      },
                                      on: { click: _vm.defaultAction },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.ctaText) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.customBacklight
                  ? [_vm._t("backlight", null, null, _vm.bindings)]
                  : [
                      _c("div", {
                        staticClass: "backlight",
                        on: { click: _vm.backlightClick },
                      }),
                    ],
              ],
              2
            )
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }